import axios from "axios";
import { esopBaseURL } from "../../../Configuration/API_URL";
import {
  ApiResDecrypt,
  encyptPayload,
} from "../../../CommonMethhods/CommonMethods";

const api = axios.create({
  baseURL: esopBaseURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("ssoToken");
    const permissions = localStorage.getItem("permissions");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (permissions) {
      config.headers.perm = permissions;
    }

    const isFormData = config.data instanceof FormData;

    config._isEncrypted = !isFormData;
    config.headers.reserv = !isFormData ? 1 : 0;

    if (!isFormData && config.data) {
      config.data = encyptPayload(config.data);
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => {
    if (!response.config._isEncrypted) {
      return response;
    }

    try {
      let data = response.data;

      if (!data) {
        return response;
      }

      response.data = ApiResDecrypt(data);
    } catch (e) {
      console.warn("Decryption failed, returning raw");
    }

    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default api;
